export const GET_ALL_CHANNEL_LIST= "GET_ALL_DEALER_LIST";
export const GET_ALL_CHANNEL_LIST_SUCCESS = "GET_ALL_DEALER_LIST_SUCCESS"; 
export const SEARCH_DEALER_ACTIVATION = "SEARCH_DEALER_ACTIVATION";
export const SEARCH_DEALER_ACTIVATION_SUCCESSFULL = "SEARCH_DEALER_ACTIVATION_SUCCESSFULL";
export const SEARCH_DEALER_ACTIVATION_REPORT_FAILED = "SEARCH_DEALER_ACTIVATION_REPORT_FAILED";
export const PROCESSED_ACTIVATION="PROCESSED_ACTIVATION";
export const PROCESSED_ACTIVATION_SUCCESSFULL = "PROCESSED_ACTIVATION_SUCCESSFULL";
export const ALL_PROCESSED_ACTIVATION_DATA="ALL_PROCESSED_ACTIVATION_DATA";
export const ALL_PROCESSED_ACTIVATION_DATA_SUCCESSFULL="ALL_PROCESSED_ACTIVATION_DATA_SUCCESSFULL";
export const RESET_DEALER_ACTIVATION_REPORT ="RESET_DEALER_ACTIVATION_REPORT";